import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (p9301)
// ============================================================

export interface QueryParams {
  empFrom: string;   // F901_01 start range
  empTo: string;     // F901_01 end range
  deptFrom: string;  // F901_32 start range
  deptTo: string;    // F901_32 end range
}

export interface EmployeeRow {
  f901_01: string;   // Employee code (PK)
  f901_11: string;   // Employee name
  f901_12: string;   // English name
  f901_13: string;   // Birthday
  f901_14: number;   // Gender
  f901_16: string;   // Address
  f901_17: string;   // Phone
  f901_19: string;   // ID number
  f901_22: string;   // Email
  f901_27: string;   // Emergency contact
  f901_28: string;   // Emergency phone
  f901_29: string;   // Blood type
  f901_31: string;   // Hire date
  f901_32: string;   // Department code
  f901_33: string;   // Job title code
  f901_34: string;   // Leave date
  f901_51: string;   // Salary grade code
  dept_name: string;         // from F106.F106_11
  job_title_name: string;    // from F902.F902_11
  salary_grade_name: string; // from F90G.F90G_16
}

// ============================================================
// Request / Response types
// ============================================================

export interface QueryResult {
  data: EmployeeRow[];
  count: number;
  message?: string;
}

export interface ListResponse {
  data: EmployeeRow[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const p9301Api = {
  /** POST /api/p9301/query — query employees by filter range */
  async query(params: Partial<QueryParams>): Promise<QueryResult> {
    const body: QueryParams = {
      empFrom: params.empFrom || '',
      empTo: params.empTo || '',
      deptFrom: params.deptFrom || '',
      deptTo: params.deptTo || '',
    };
    const res = await apiClient.post('/api/p9301/query', body);
    return res.data;
  },

  /** GET /api/p9301 — list all employees with pagination */
  async list(page = 1, size = 20): Promise<ListResponse> {
    const res = await apiClient.get('/api/p9301', { params: { page, size } });
    return res.data;
  },

  /** GET /api/p9301/:id — get a single employee */
  async get(empCode: string): Promise<EmployeeRow> {
    const res = await apiClient.get(`/api/p9301/${encodeURIComponent(empCode)}`);
    return res.data;
  },

  /** GET /api/p9301/lookup/:type/:code — lookup department or job title name */
  async lookupName(type: 'department' | 'jobtitle', code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/p9301/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
